import React, { Component } from 'react';
import { Pagination } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import {PAGE_LIMIT, CSV_PARAMS} from "./config";
import {CSVLink} from "react-csv";

class PuhsapiExtended extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            subid: [],
            report: [],
            reportTotal: {},
            countries: [],
            pagesTotal: 0,
            activePage: 1,
            sortParam: null,
            sortOrder: 1,
            isLoading: false
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;


        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleFieldChange(event) {
        const { value, name } = event.target;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === 'affid') return this.loadAffidReport(filters, type);
        if(type === 'subid') return this.loadSubids(filters);

        this.loadReport(filters, type);
    }

    loadReport(filters, type) {
        API.Pushapi.getExtended(filters, type).then(({ report, total }) => {
            const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);
            const stateUpdates = { report, reportTotal: total, pagesTotal, activePage: 1, isLoading: false };

            this.setState(stateUpdates)
        });
    }

    loadAffidReport(filters, type) {
        API.Pushapi.getExtended(filters, type).then(({ report, total }) => {
            const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);
            const stateUpdates = { report, reportTotal: total, pagesTotal, isLoading: false };

            stateUpdates.affidValues = report.map(({ a }) => a);

            this.setState(stateUpdates)
        });
    }

    loadSubids(filters) {
        API.Pushapi.getSubids(filters).then(subids => this.setState({ subidValues: subids, isLoading: false }));
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    getTable() {
        const { report, reportTotal, activePage } = this.state;

        return report.length ?
            <Table report={report} total={reportTotal} activePage={activePage} onSortChange={this.handleSort} /> :
            <p>No Data</p>
    }

    getExportCsvButton() {
        let headers = CSV_PARAMS.map(([ param, label ]) => ({ key: param, label: label }));

        return <CSVLink data={this.state.report} headers={headers} className="btn btn-primary">Export CSV</CSVLink>;
    }

    render() {
        const { isLoading, affidValues, subidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Pushapi Extended"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} subidValues={subidValues}/>
                {this.getExportCsvButton()}

                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default PuhsapiExtended;


// WEBPACK FOOTER //
// ./src/scenes/PushapiExtended/index.js